import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
// The shared sheets first, so a screen's own sheet (imported by its component) comes after them and wins.
import "./ui/tokens.css";
import "./styles.css";
import "./collab/collab.css";
import "./ui/kit.css";
import "./ui/motion.css";
import { App } from "./App.tsx";
import { applyBrand } from "./brand.ts";
import { reloadForNewChunks } from "./chunks.ts";
import { applyLocale } from "./locale.ts";

applyBrand();
applyLocale();
window.addEventListener("vite:preloadError", (e) => reloadForNewChunks(e, () => window.location.reload()));

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
